(function () {
  var desktopQuery = window.matchMedia('(min-width: 769px)');
  var frame;
  var settleTimer;

  function positionOpenMegaMenus() {
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(function () {
      document.querySelectorAll('.site-nav--is-megamenu > details').forEach(function (details) {
        var menu = details.querySelector(':scope > .megamenu');
        var trigger = details.querySelector(':scope > summary');

        if (!menu || !trigger || !desktopQuery.matches) return;

        var detailsLeft = details.getBoundingClientRect().left;
        var triggerBottom = Math.round(trigger.getBoundingClientRect().bottom);
        var menuLeft = details.open ? 0 : detailsLeft * -1;
        menu.style.setProperty('--xs-megamenu-left', menuLeft + 'px');
        menu.style.setProperty('--xs-megamenu-bottom', triggerBottom + 'px');
      });
    });
  }

  function bindMegaMenus() {
    document.querySelectorAll('.site-nav--is-megamenu > details').forEach(function (details) {
      if (details.dataset.xsMegaMenuBound === 'true') return;

      details.dataset.xsMegaMenuBound = 'true';
      details.addEventListener('toggle', positionOpenMegaMenus);
      details.querySelector('summary').addEventListener('click', positionOpenMegaMenus);
    });

    positionAfterHeaderSettles();
    window.setTimeout(positionOpenMegaMenus, 1000);
    window.setTimeout(positionOpenMegaMenus, 2500);
  }

  function positionAfterHeaderSettles() {
    positionOpenMegaMenus();
    window.clearTimeout(settleTimer);
    settleTimer = window.setTimeout(positionOpenMegaMenus, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindMegaMenus);
  } else {
    bindMegaMenus();
  }

  window.addEventListener('resize', positionAfterHeaderSettles, { passive: true });
  window.addEventListener('scroll', positionAfterHeaderSettles, { passive: true });
})();
